__turbopack_context__.v({
  "actions": "BlockPromotionPod-module-scss-module__E7gpEG__actions",
  "banner": "BlockPromotionPod-module-scss-module__E7gpEG__banner",
  "description": "BlockPromotionPod-module-scss-module__E7gpEG__description",
  "flushBottom": "BlockPromotionPod-module-scss-module__E7gpEG__flushBottom",
  "flushTop": "BlockPromotionPod-module-scss-module__E7gpEG__flushTop",
  "headline": "BlockPromotionPod-module-scss-module__E7gpEG__headline",
  "icon": "BlockPromotionPod-module-scss-module__E7gpEG__icon",
  "leadingButton": "BlockPromotionPod-module-scss-module__E7gpEG__leadingButton",
  "loadingMessage": "BlockPromotionPod-module-scss-module__E7gpEG__loadingMessage",
  "root": "BlockPromotionPod-module-scss-module__E7gpEG__root",
});
